import { ScrollPositionAnalytics } from '@/core/analytics.js'

const ScrollPositionAnalyticsMixin = (app, window) => {
  return {
    data: function () {
      return {
        analytics__: new ScrollPositionAnalytics(app.analytics(), window)
      }
    },
    mounted() {
      this.analytics__.start()
    },
    destroyed() {
      this.analytics__.stop()
    }
  }
}

export { ScrollPositionAnalyticsMixin }
